import { useEffect, useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Trophy, Calendar } from 'lucide-react';
import api from '@/lib/api';

export default function OwnerRankings() {
    const [ranking, setRanking] = useState([]);
    const [loading, setLoading] = useState(true);
    const [weekInfo, setWeekInfo] = useState({ start: '', end: '' });

    useEffect(() => {
        const fetchRanking = async () => {
            setLoading(true);
            try {
                const res = await api.get('/owner/rankings/general');
                setRanking(res.data.data || []);
                setWeekInfo({ start: res.data.week_start, end: res.data.week_end });
            } catch { setRanking([]); }
            finally { setLoading(false); }
        };
        fetchRanking();
    }, []);

    return (
        <div>
            <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 mb-6">
                <h1 className="text-2xl font-bold uppercase tracking-wide text-white">Rankings</h1>
                <div className="flex items-center gap-2 text-sm text-white/60">
                    <Calendar className="h-4 w-4" />
                    <span>Semana: {weekInfo.start} al {weekInfo.end}</span>
                </div>
            </div>

            <Card className="bg-[#0a0a0a] border-[#3a3a3f]">
                <CardHeader>
                    <CardTitle className="flex items-center gap-2 text-white uppercase tracking-wide text-base">
                        <Trophy className="h-5 w-5 text-white" />
                        Ranking General Semanal
                    </CardTitle>
                </CardHeader>
                <CardContent>
                    {loading ? (
                        <p className="text-white/60 text-center py-8">Cargando...</p>
                    ) : ranking.length === 0 ? (
                        <p className="text-white/60 text-center py-8">Aún no hay puntos registrados esta semana.</p>
                    ) : (
                        <div className="space-y-2">
                            {ranking.map((r, idx) => (
                                <div key={r.customer_id} className={`flex items-center justify-between p-3 rounded-lg border border-[#3a3a3f] hover:bg-white/5 ${idx === 0 ? 'bg-white/5' : ''}`}>
                                    <div className="flex items-center gap-3">
                                        <span className={`text-sm font-bold w-6 text-center ${idx === 0 ? 'text-yellow-400' : idx === 1 ? 'text-gray-300' : idx === 2 ? 'text-orange-400' : 'text-white/60'}`}>
                                            {idx + 1}
                                        </span>
                                        <p className="font-medium text-sm text-white">{r.nombre}</p>
                                    </div>
                                    <span className="text-sm font-bold text-white">{r.total_points} pts</span>
                                </div>
                            ))}
                        </div>
                    )}
                </CardContent>
            </Card>
        </div>
    );
}
